module.exports = __webpack_public_path__ + "img/dashboards_metrics.244d9523.png";